import React, { useEffect, useState } from 'react'
// import CryptoJS from 'crypto-js'
import { Tabs, Input } from '@mantine/core'
import { LoadingOverlay } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { useInterval } from '@mantine/hooks'
import { Modal, Button, Toast } from '@ow/comps'
import { useAppEx, useUser } from '@vt/hooks'
import QRCode from 'qrcode.react'
import { getQuery } from '@vt/utils'
import { editUser } from '@vt/apis/lib-ex/v2/users'
import {
  roleList,
  orgNameList,
  getFaceRecognitionState,
  getFaceAuth,
  getSignDetailForInvestigation,
  encryptStr,
  decryptStr,
} from './utils'
import dygcappImg from './dygcapp.png'
import OnlyFace from './OnlyFace'

const FaceRecognition = function ({ afterFaceRecognition }) {
  const { userInfoInApp, appId, appConfigMutate } = useAppEx()
  // 用户是否已填写手机号
  const [isUserIdentifyValid, setIsUserIdentifyValid] = useState(false)
  const [uniqueIdInput, setUniqueIdInput] = useState(null)
  // 当前用户是否需要实名
  const [isNeedRealName, setIsNeedRealName] = useState(false)
  const [isNeedSign, setIsNeedSign] = useState(false)
  const [isSignPass, setIsSignPass] = useState(false)
  const [loading, setLoading] = useState(true)

  const { logOut } = useUser()
  const { tpl } = getQuery()
  // 当前签署信息
  const [signInfo, setSignInfo] = useState({})

  const updateUserInfo = () => {
    // 调接口更新用户信息
    if (uniqueIdInput) {
      if (!/^\d{17}[0-9Xx]$/.test(uniqueIdInput)) {
        Toast.error({ title: '请输入有效身份证号码' })
      } else {
        editUser(appId, {
          id: userInfoInApp.id,
          uniqueId: encryptStr(uniqueIdInput),
        }).then(() => {
          // appConfigMutate()

          Toast.success({ title: '确认完毕，请您重新登录' })

          setTimeout(() => {
            logOut(tpl)
          }, 3000)
        })
      }
    }
  }

  // const fetchFaceRegnition = async () => {
  //   const res = await getFaceRecognitionState(
  //     decryptStr(userInfoInApp.uniqueId),
  //     {
  //       // params: { indentNo: userInfoInApp.uniqueId },
  //       ignoreAuthorization: true,
  //     }
  //   )
  //   if (res.data) {
  //     if (res.data.updateTime) {
  //       const updateTime = new Date(res.data.updateTime).getTime()

  //       localStorage.setItem(
  //         `${appId}_${userInfoInApp.userId}_lastRecognitionTime`,
  //         updateTime
  //       )

  //       Toast.success({ title: '您已完成人实名认证' })

  //       interval.stop()
  //     }
  //   } else {
  //   }
  // }

  // const interval = useInterval(() => fetchFaceRegnition(), 5000)

  // 需要轮询
  const getFaceAuthInfo = async () => {
    const res = await getFaceAuth(userInfoInApp.uniqueId, {
      // params: { indentNo: userInfoInApp.uniqueId },
      ignoreAuthorization: true,
    })

    setIsUserIdentifyValid(true)
    if ([1, '1'].includes(res.data?.authState)) {
      // 已完成了实名认证,不需要再认证了
      setIsNeedRealName(false)
      intervalFaceAuth.stop()
      setLoading(false)
      // 直接去判断签署相关的
      intervalSign.start()
    } else {
      setLoading(false)
      // 必须再实名认证
      setIsNeedRealName(true)
    }
  }

  const checkFullInfoSign = async (num) => {
    if (userInfoInApp.uniqueId) {
      // getFaceAuthInfo()
      intervalFaceAuth.start()
    } else {
      setLoading(false)
      // 需要弹框补充信息
      setIsUserIdentifyValid(false)
    }
  }

  // 校验签署权限
  const checkUserRealPower = () => {
    const currentRole = userInfoInApp.roleSlug
    // 是否强制实名
    if (userInfoInApp.forceRealName) {
      // 检查员、管理员、审核员需要签署
      if (roleList.includes(currentRole)) {
        // 海淀的项目
        if (appId === 1015 || appId === 1073) {
          setIsNeedSign(orgNameList.includes(userInfoInApp.orgName))
          // 如果需要签署，就开始验证一下信息是否完善
          if (orgNameList.includes(userInfoInApp.orgName)) {
            checkFullInfoSign()
          } else {
            setIsSignPass(true)
            setLoading(false)
          }
        } else {
          setIsNeedSign(true)
          // 如果需要签署，就开始验证一下信息是否完善
          checkFullInfoSign()
        }
      } else {
        // 放行
        setIsNeedSign(false)
        setIsSignPass(true)
        setLoading(false)
      }
    } else {
      // 放行
      setIsNeedSign(false)
      setIsSignPass(true)
      setLoading(false)
    }
  }

  // 判断任务书签署
  const getSignDetailForInvestigationInfo = async () => {
    const res = await getSignDetailForInvestigation(
      userInfoInApp.uniqueId,
      appId,
      {
        ignoreAuthorization: true,
      }
    )
    setSignInfo(res.data)
    if (!res.data.needSign || [2, '2'].includes(res.data.signState)) {
      intervalSign.stop()
      showNotification({
        title: '您已完成签署',
      })
      console.log('去人脸吧')
      setIsSignPass(true)
    }
  }

  const intervalSign = useInterval(
    () => getSignDetailForInvestigationInfo(),
    5000
  )

  const intervalFaceAuth = useInterval(() => getFaceAuthInfo(), 5000)

  useEffect(() => {
    // 判断是否需要签署任务书
    checkUserRealPower()
  }, [userInfoInApp])

  if (loading) {
    return <LoadingOverlay visible={loading} />
  }
  if (!isUserIdentifyValid && isNeedSign && !isSignPass) {
    return (
      <Modal
        closeOnDocumentClick={false}
        contentStyle={{ height: '80vh', width: '60vw' }}
        maxHeight="80vh"
        open
      >
        <div class="w-full flex flex-col gap-4">
          <p>为确保信息安全，需确认您的身份(请务必准确填写)</p>
          <Input
            style={{ width: '100%' }}
            placeholder="请输入您的身份证号码"
            onChange={(e) => {
              const { value } = e.target

              setUniqueIdInput(value)
            }}
          />
          <Button type="primary" onClick={updateUserInfo} className="w-[100px]">
            确定
          </Button>
        </div>
      </Modal>
    )
  }
  // 需要实名认证
  if (isUserIdentifyValid && isNeedRealName && !isSignPass) {
    return (
      <Modal
        closeOnDocumentClick={false}
        contentStyle={{ height: '80vh', width: '60vw' }}
        maxHeight="80vh"
        open
      >
        <Tabs defaultValue="face">
          <Tabs.List>
            <Tabs.Tab value="face">人脸识别验证</Tabs.Tab>
            <Tabs.Tab value="app">下载调研工厂调查员版App</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="face" pt="xs">
            <div class="flex justify-center text-center flex-col mt-4">
              <p>为确保信息安全，需确认您的身份</p>
              <p> 请使用“调研工厂调查员版”App</p>
              <p>扫描下方二维码进行人脸识别验证</p>
              <div class="p-4 flex justify-center items-center display-block">
                <QRCode
                  value={`http/survey?idNum=${userInfoInApp.uniqueId}`}
                  size={250}
                />
              </div>
            </div>
          </Tabs.Panel>
          <Tabs.Panel value="app" pt="xs">
            <div class="flex justify-center text-center mt-4 flex-col">
              <p>请使用手机扫描下方二维码，下载“调研工厂调查员版”App</p>
              <p>完成App下载后，使用您当前的账号进行登录</p>
              <p> 使用App扫码功能扫描“人脸识别验证”中的二维码进行验证</p>
            </div>
            <div class="p-4 flex justify-center items-center display-block">
              <img
                src={dygcappImg}
                style={{
                  width: '250px',
                  height: '250px',
                  marginBottom: '6px',
                }}
                alt=""
              />
            </div>
          </Tabs.Panel>
        </Tabs>
      </Modal>
    )
  }
  // 任务书签署弹框
  if (
    signInfo?.needSign &&
    ![2, '2'].includes(signInfo.signState) &&
    !isSignPass
  ) {
    return (
      <Modal
        closeOnDocumentClick={false}
        contentStyle={{ height: '80vh', width: '60vw' }}
        maxHeight="80vh"
        open
      >
        <Tabs defaultValue="face">
          <Tabs.List>
            <Tabs.Tab value="face">任务书签署</Tabs.Tab>
            <Tabs.Tab value="app">下载调研工厂调查员版App</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="face" pt="xs">
            <div class="flex justify-center text-center flex-col mt-4">
              <p>请您打开“调研工厂调查员版”App</p>
              <p> 扫码进行本项目的任务书签署操作</p>
              <p>如不签署任务书将无法为您结算劳务费</p>
              <div class="p-4 flex justify-center items-center display-block">
                <QRCode
                  value={`http/survey?identEncrypted=${userInfoInApp.uniqueId}&projectId=${appId}&type=${signInfo.signState}&subProjectCategory=2`}
                  size={250}
                />
              </div>
            </div>
          </Tabs.Panel>
          <Tabs.Panel value="app" pt="xs">
            <div class="flex justify-center text-center mt-4 flex-col">
              <p>如未安装“调研工厂调查员版”App</p>
              <p>请扫描下方二维码下载App</p>
              <p>使用App扫描左侧二维码进行验证</p>
            </div>
            <div class="p-4 flex justify-center items-center display-block">
              <img
                src={dygcappImg}
                style={{
                  width: '250px',
                  height: '250px',
                  marginBottom: '6px',
                }}
                alt=""
              />
            </div>
          </Tabs.Panel>
        </Tabs>
      </Modal>
    )
  }
  if (isSignPass) {
    return <OnlyFace />
  }
  return null
}

export default FaceRecognition
